import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import config from 'devextreme/core/config';
import App from './App';
import '@jarvis/platform-ui/tokens.css';
import '@jarvis/platform-ui/styles.css';
import './app.css';
import { bootstrapTheme } from './theme/useThemeStore';

bootstrapTheme();

// Clear latch left by an earlier auto-reload experiment (can strand OIDC mid-login).
try {
  sessionStorage.removeItem('jarvis:chunk-reload');
} catch {
  /* ignore */
}

const licenseKey = import.meta.env.VITE_DEVEXTREME_LICENSE_KEY;
if (licenseKey) {
  config({ licenseKey });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
